var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFolderUpload = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#folder-upload_svg__a)",
  opacity: 0.4
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002,
  d: "M6.676 11.35V7.583m0 0L8.12 9.089M6.676 7.582 5.233 9.089m-1.227 2.262h-.939c-.956 0-1.732-.81-1.732-1.81V3.813c0-.999.776-1.809 1.732-1.809h1.527c.58 0 1.12.302 1.442.806l.298.466c.214.336.574.537.96.537h2.992c.956 0 1.732.81 1.732 1.81v3.92c0 .999-.776 1.809-1.732 1.809h-.939"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "folder-upload_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h13.354v13.354H0z"
})))));
export default SvgFolderUpload;